import { IonFab, IonFabButton, IonFabList, IonIcon } from "@ionic/react";
import { apps, home } from "ionicons/icons";

export interface WithFabProps {
	buttons: any[];
	children: any;
}

const WithFab = ({ buttons, children }: WithFabProps) => {
	const buttonsNullOrEmpty = !buttons || buttons.length <= 0;

	const FABContainer = ({ singleButton, children }) =>
		singleButton ? (
			<>{children}</>
		) : (
			<>
				<IonFabButton>
					<IonIcon icon={apps}></IonIcon>
				</IonFabButton>
				<IonFabList side="top">{children}</IonFabList>
			</>
		);
	const renderButtonsList = (buttonsList) =>
		buttonsList.length === 0 ? (
			<></>
		) : (
			<FABContainer singleButton={buttonsList.length === 1}>
				{buttonsList.map((button, idx) => (
					<IonFabButton key={idx} onClick={button.onClick}>
						<IonIcon icon={button.icon} />
					</IonFabButton>
				))}
			</FABContainer>
		);

	return (
		<>
			{children}
			{!buttonsNullOrEmpty && (
				<IonFab
					class="options-button"
					vertical="bottom"
					horizontal="end"
					edge
					slot="fixed"
				>
					{renderButtonsList(buttons || [])}
				</IonFab>
			)}
		</>
	);
};

export default WithFab;
